<template>
  <div class="convention-hall page">
    <!-- 顶部导航栏（浅紫渐变） -->
    <van-nav-bar class="nav-bar" :title="$t('foorter.video')">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <!-- 两个Tab切换按钮 -->
    <div class="tab-buttons">
      <div class="tab-btn orange" :class="{ active: activeKey === 0 }" @click="onChange(0)">
        {{$t('auth.top36')}}
      </div>
      <div class="tab-btn blue" :class="{ active: activeKey === 1 }" @click="onChange(1)">
         {{$t('auth.top37')}}
      </div>
    </div>

    <!-- 商家列表 -->
    <div class="list-container">
      <div class="goods-grid">
        <div class="goods-card" v-for="(v, key) in filteredList" :key="key" @click="toLottery(v.key, v.id)">
          <div class="card-left">
            <img :src="v.ico" class="logo-img" />
          </div>
          <div class="card-right">
            <div class="goods-name">{{ getGameName(v) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gameitem: [],
      activeKey: 0,
      lang: localStorage.getItem("lang") || "zh"
    };
  },
  computed: {
    // 根据 activeKey 筛选数据
    filteredList() {
      if (this.activeKey === 1) {
        // 热门商家：hot 为 1
        return this.gameitem.filter(item => item.hot == 1);
      }
      // 全部商家
      return this.gameitem;
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
      } else {
        this.$router.push({ path: '/Lottery?key=' + key + "&id=" + id });
      }
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        this.gameitem = res.data;
      });
    },
    onChange(index) {
      // 纯前端切换，不请求接口
      this.activeKey = index;
    },
    getGameName(v) {
      if (this.lang == 'zh') return v.name;
      if (this.lang == 'en') return v.name_es;
      if (this.lang == 'ja') return v.name_ja;
      if (this.lang == 'kr') return v.name_kr;
      return v.name;
    }
  },
  created() {
    this.getGameItem();
  }
};
</script>

<style lang="less" scoped>
.page {
  min-height: 100VH;
  background: #f7f8fa;
  padding-bottom: 80PX;
}

/* 顶部导航栏 - 浅紫渐变 */
.nav-bar {
  background: #8600ff !important;
  :deep(.van-nav-bar__title) {
    color: #fff;
    font-size: 18PX;
    font-weight: 600;
  }
  :deep(.van-icon) {
    color: #fff;
  }
}

/* 两个Tab按钮 */
.tab-buttons {
  display: flex;
  gap: 10PX;
  padding: 15PX 12PX;
  background: #f7f8fa;
}

.tab-btn {
  flex: 1;
  height: 44PX;
  line-height: 44PX;
  text-align: center;
  border-radius: 8PX;
  font-size: 15PX;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}

.tab-btn.orange {
  background: linear-gradient(90deg, #ff7e5f, #ff5f6d);
}

.tab-btn.blue {
  background: linear-gradient(90deg, #4facfe, #00f2fe);
}

.tab-btn.active {
  opacity: 0.9;
  box-shadow: 0 4PX 10PX rgba(0, 0, 0, 0.1);
}

/* 商家列表区域 */
.list-container {
  padding: 0 12PX;
}

.goods-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12PX;
}

/* 商家卡片 */
.goods-card {
  background: #fff;
  border-radius: 10PX;
  padding: 15PX 10PX;
  display: flex;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 2PX 8PX rgba(0, 0, 0, 0.05);
}

.card-left {
  flex-shrink: 0;
}

.logo-img {
  width: 50PX;
  height: 50PX;
  border-radius: 10PX;
  object-fit: contain;
}

.card-right {
  margin-left: 10PX;
  flex: 1;
  overflow: hidden;
}

.goods-name {
  font-size: 14PX;
  font-weight: 700;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.goods-desc {
  font-size: 12PX;
  color: #999;
  margin-top: 4PX;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.goods-time {
  font-size: 13PX;
  font-weight: 600;
  color: #333;
  margin-top: 4PX;
}
::v-deep .van-nav-bar__title {
  color: #fff !important;
  font-size: 18PX;
  font-weight: 600;
  text-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.8);
}

::v-deep .van-nav-bar__text {
  color: #fff !important;
}
</style>